const QUIZ_ID = '6a3e2b42b9ac010019b7ac37';
const BUTTON_SELECTOR = '[data-ai-banner-quiz]';

export default () => {
  const buttons = document.querySelectorAll(BUTTON_SELECTOR);

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      // если Marquiz не загрузился, оставляем переход по href в новой вкладке
      if (!window.Marquiz) return;

      event.preventDefault();
      Marquiz.showModal(QUIZ_ID);
    });
  });
};
